import { render, staticRenderFns } from "./ClvModalCurrencyPairs.vue?vue&type=template&id=957ec6d8&"
import script from "./ClvModalCurrencyPairs.vue?vue&type=script&lang=js&"
export * from "./ClvModalCurrencyPairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports